import AnalyticsBase from './AnalyticsBase';

class RouteEvent extends AnalyticsBase {
  pathname: string;

  search: string;
}

export default RouteEvent;
